import {InitPageStrict} from "../index";

declare var App: any;
declare var storeLocation: string;

class TheftAlertsInstant {
  missingAlertChannel: any;

  constructor() {
    this.missingAlertChannel = App.cable.subscriptions.create(
      // Connection configuration
      {
        channel: "MissingAlertChannel",
        tenant_code: storeLocation
      },
      // Pass in connection callbacks
      {
        connected() { /* Called when the subscription is ready for use on the server */ },
        disconnected() { /* Called when the subscription has been terminated by the server */ },
        received: (data: any) => this.onNewMissingAlert(data)
      }
    );
  }

  onNewMissingAlert(data) {
    $("#latest-missing-alert").html(`
      <p>${data['last_seen']}</p>
      <p>${data['location_name'] || "-"}</p>
      <p>${data['category_name'] || "-"}</p>
      <p>${data['description'] || "-"}</p>
      <p>${data['epc_id']}</p>
    `);
    $("#latest-missing-alert").show();
    
    $.ajax({
      dataType: 'jsonp',
      url: "missing_items.js"
    });
  }
}

export function LoadPage() {
  InitPageStrict("alerts missing_items", () => {
    const m = new TheftAlertsInstant();
  });
}
